/** Every cursor image `cursors.scss` uses (each also has an `@2x` version). */
const CURSOR_IDS = ['default', 'interact', 'attack', 'help', 'disabled', 'move', 'grab', 'grabbing', 'turn', 'text'] as const;

/**
 * The preloaded images, held for the page's lifetime: an image nothing
 * references can be dropped from Chrome's memory cache, and the next cursor
 * change to it loads it again, showing the fallback keyword meanwhile.
 */
const heldCursorImages: HTMLImageElement[] = [];

/**
 * Fetches and decodes the cursor images up front, and keeps them. Chrome
 * loads a cursor image the first time it is needed and shows the fallback
 * keyword cursor (e.g. the system crosshair for attack) until it arrives.
 */
export function preloadCursorImages(): void {
    for (const id of CURSOR_IDS) {
        for (const suffix of ['', '@2x']) {
            const image = new Image();
            image.src = `/cursors/${id}${suffix}.png`;
            // A failed decode just leaves the image to load when first shown.
            image.decode().catch(() => undefined);
            heldCursorImages.push(image);
        }
    }
}
